import styled, {keyframes} from 'styled-components';

import {colors} from 'theme';

const showKeyframe = keyframes`
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

export const HintText = styled.span<{isError: boolean}>`
    font-size: 10px;
    line-height: 12px;
    margin: 0 0 0 8px;
    ${(p) => p.isError && `color: ${colors.danger}`};
    animation: ${showKeyframe} 0.3s;
`;
